import cn from 'classnames';

import * as st from './index.module.scss';

interface IProps {
	tabs: (string | null)[];
	selected: string | null;
	setTab: (tab: string | null) => void;
}

const Tabs = ({ tabs, selected, setTab }: IProps): JSX.Element => {
	const getTabName = (tab: string | null) => {
		let name: string | null = null;
		switch (tab) {
			case 'description':
				name = 'Описание';
				break;
			case 'specifications':
				name = 'Характеристики';
				break;
			default:
				break;
		}
		return name;
	};

	return (
		<div className={st.tabs}>
			{tabs.map(
				(tab) =>
					tab && (
						<button
							key={tab}
							className={cn(st.tab, selected === tab && st.active)}
							onClick={() => setTab(tab)}
						>
							{getTabName(tab)}
						</button>
					)
			)}
		</div>
	);
};

export default Tabs;
